



































import Vue from 'vue'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import SubmitButton from '@/components/buttons/SubmitButton.vue'
import AuthService from '@/services/authentication.service'
import { errorMessages } from '@/utils/helpers'

export default Vue.extend({
  name: 'ResetPassword',
  components: { SubmitButton },
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      showPassword: false,
      showPasswordConfirmation: false,
      token: this.$route.query.token,
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    passwordConfirmation: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  computed: {
    passwordFieldType(): string {
      return this.showPassword ? 'text' : 'password'
    },
    passwordFieldIcon(): string {
      return this.showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
    },
    passwordConfirmationFieldType(): string {
      return this.showPasswordConfirmation ? 'text' : 'password'
    },
    passwordConfirmationFieldIcon(): string {
      return this.showPasswordConfirmation ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
    },
    passwordErrors(): string[] {
      const errors: string[] = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push(this.$t('validation.requiredField', { field: 'Password' }) as string)
      !this.$v.password.minLength && errors.push(this.$t('passwordMinLength') as string)
      return errors
    },
    passwordConfirmationErrors(): string[] {
      const errors: string[] = []
      if (!this.$v.passwordConfirmation.$dirty) return errors
      !this.$v.passwordConfirmation.required &&
        errors.push(this.$t('validation.requiredField', { field: 'Password Confirmation' }) as string)
      !this.$v.passwordConfirmation.sameAsPassword && errors.push(this.$t('passwordsMustMatch') as string)
      return errors
    },
  },
  methods: {
    toggleShowPassword(): void {
      this.showPassword = !this.showPassword
    },
    toggleShowPasswordConfirmation(): void {
      this.showPasswordConfirmation = !this.showPasswordConfirmation
    },
    async submit() {
      this.$v.$touch()
      if (this.$v.$anyError) return

      const loader = this.$loading.show()
      try {
        const response = await AuthService.resetPassword(
          this.token.toString(),
          this.password,
          this.passwordConfirmation,
        )
        this.$toast.success(response.data.message)
        await this.$router.push({ name: 'Login' })
      } catch (err) {
        if (err.response?.data) {
          this.$toast.error(errorMessages(err.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
    checkToken(): void {
      if (!this.token) {
        this.$router.push({ name: 'Login' })
        return
      }
      AuthService.verifyPasswordResetToken(this.token.toString()).catch(() => {
        this.$toast.error(this.$t('invalidOrExpiredToken') as string)
        this.$router.push({ name: 'ForgotPassword' })
      })
    },
  },
  beforeMount() {
    this.checkToken()
  },
})
